import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getSingleTransaction } from '../../../redux/modules/subscriptions';
import SingleTransaction from './single';

class Transaction extends Component {
  static fetchData({ dispatch, params }) {
    return dispatch(getSingleTransaction(params.id));
  }

  render() {
    const { current } = this.props;

    if (!current) {
      return null;
    }
    return <SingleTransaction current={current} />;
  }
}

export default connect(
  ({
    subscriptions: {
      transactions: { current }
    }
  }) => ({ current }),
  { getSingleTransaction }
)(Transaction);
